import { AxiosPromise } from 'axios';
import { AxiosClientFactory } from '../../../common/helpers/AxiosClientFactory';
import { ConsumerLoan } from '../models/ConsumerLoan';

export const getConsumerLoan = (personId: number | string, loanId: number | string): AxiosPromise<ConsumerLoan> => {
    return AxiosClientFactory
        .getInstance()
        .get<ConsumerLoan>(`/api/applicants/${personId}/consumerLoans/${loanId}`);
};
